import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmMessageRequest, guestLoginPhone, guestVerification, userLogin } from "../../assets/api/userActions";
import './index.scss'
import { useEffect } from "react";

const GuestLogin = () => {

    const params = useParams();
    const navigate = useNavigate();

    const [loginPhone, setLoginPhone] = useState("");
    const [loginName, setLoginName] = useState("");
    const [checked, setChecked] = useState(false);
    const [verify, setVerify] = useState();

    const { isAbove922 } = useMediaQueries();

    const validExamHandler = (data) => {
        if (!data.validation) {
            navigate("/service/not-active");
        }
        else if (!data.guest) {
            navigate("/guest/not-active");
        }
    }
    const fetchGuestValidation = async () => {
        guestVerification(params.code).then(res => { setVerify(res); validExamHandler(res) });
    }


    useEffect(() => {
        fetchGuestValidation()
    }, [])


    function onNavigateToConfirm() {
        window.sessionStorage.setItem("guestInfo", JSON.stringify({ name: loginName, phone: loginPhone }));
        navigate(`/auth/login/guest/confirm/${params.code}`);
    }

    function resHandler(res) {
        const today = new Date();
        let tomorrow = new Date();
        const setExpireDate = tomorrow.setDate(today.getDate() + 1);
        const { token, ...newUserData } = res;
        // console.log(quizToken);
        localStorage.setItem("userToken", JSON.stringify({
            ...newUserData, quizToken: token, "expireDate": setExpireDate
        }))
        navigate("/quiz/join/" + params.code)

    }

    const onSubmitHandler = async (e) => {
        e.preventDefault();
        var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
        if (loginPhone.length !== 11 && loginPhone.length !== 0) {
            Swal.fire({
                icon: "error",
                title: "شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"
            })
            return
        }
        else if (!loginPhone.length) {
            Swal.fire({
                icon: "error",
                title: "شماره خود را وارد کنید",
                confirmButtonText: "باشه"
            })
            return;
        }
        else if (!regex.test(loginPhone.toString())) {
            Swal.fire({
                icon: "error",
                title: "فرمت شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"
            })
            return;
        }
        else if (!checked) {
            Swal.fire({
                icon: "error",
                title: "لطفا با شرایط و ضوابط سایت موافقت بفرمایید",
                confirmButtonText: "باشه"
            })

        }
        else {
            if (verify.guestDetection) {
                await confirmMessageRequest(
                    loginName,
                    loginPhone,
                    params.code
                ).then(res => res.returnCode === "SUCCESS" && onNavigateToConfirm());
            }
            else {
                console.log("hi");
                console.log(verify);
                guestLoginPhone({ name: loginName, phone: loginPhone, quiz_code: params.code }).then(res => resHandler(res))
            }
        }
    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    return (
        // {
        //         !isLoading ?

        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">

                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود به صورت مهمان</h4>
                            <p className="login-description">اطلاعات زیر را وارد کنید</p>
                            <input
                                type="text"
                                className="input-style"
                                placeholder="نام و نام خانوادگی"
                                onChange={(e) => {
                                    setLoginName(e.target.value);
                                }}
                            />
                            <input
                                type="number"
                                className="input-style"
                                placeholder="شماره موبایل"
                                onChange={(e) => {
                                    setLoginPhone(e.target.value);
                                }}
                            />
                            <div className="checkbox-input-wrapper">
                                <input type="checkbox" onChange={() => setChecked(!checked)} />
                                <p className="check-title">
                                    با در اختیار قرار گرفتن اطلاعات کاربری خود برای برگزار کننده موافق هستم.
                                </p>
                            </div>
                            <button
                                type="submit"
                                className="button-login"
                            >
                                {
                                    verify?.guestDetection ?
                                        "ثبت و ادامه" :
                                        "ورود"
                                }

                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>

    )
}

export default GuestLogin